export default function containsUppercase(str) {
  return /[A-Z]/.test(str);
}
